import { MaskedLine, Reveal } from "../components/motion";
import BookMockup from "../components/BookMockup";
import CtaButton from "../components/CtaButton";
import { config } from "../config/siteConfig";

const FinalCta = () => (
  <section
    id="final-cta"
    data-testid="final-cta-section"
    className="relative min-h-[100svh] bg-[#050F1E] text-white overflow-hidden flex items-center"
  >
    <div className="absolute inset-0 hero-grid pointer-events-none" />
    <div className="hidden lg:block absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[70vw] h-[70vw] rounded-full bg-[#12294D] blur-[160px] opacity-60 pointer-events-none" />

    <div className="relative max-w-7xl mx-auto px-5 sm:px-8 py-28 w-full text-center">
      <h2 className="font-display tracking-[0.02em] leading-[1.05] text-[clamp(1.9rem,5vw,4.25rem)]">
        <MaskedLine delay={0.05}>YOU CAN SPEND ANOTHER YEAR</MaskedLine>
        <MaskedLine delay={0.18}>TRYING TO FIGURE OUT</MaskedLine>
        <MaskedLine delay={0.31} className="text-white/40">WHAT TO DO NEXT.</MaskedLine>
      </h2>

      <Reveal delay={0.5} className="mt-8">
        <p className="font-mono text-xs sm:text-sm uppercase tracking-[0.35em] text-[#D4AF37]">
          Or you can follow the blueprint.
        </p>
      </Reveal>

      <div className="mt-16 grid lg:grid-cols-2 items-center gap-10 lg:gap-6">
        <div className="lg:order-2 flex justify-center lg:justify-end">
          <div className="scale-[0.8] sm:scale-90 lg:scale-100 origin-center -my-6 lg:my-0">
            <BookMockup />
          </div>
        </div>
        <p className="lg:order-1 mt-16 lg:mt-0 text-center lg:text-left font-sans font-extrabold uppercase tracking-[-0.02em] leading-[0.92] text-[clamp(2.6rem,9vw,7.5rem)]">
          <MaskedLine delay={0.1}>BUILD IT.</MaskedLine>
          <MaskedLine delay={0.22} className="text-white/35">TEST IT.</MaskedLine>
          <MaskedLine delay={0.34} className="text-[#D4AF37]">SCALE IT.</MaskedLine>
        </p>
      </div>

      <Reveal delay={0.5} className="mt-14">
        <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-white/50">
          {config.book.title}
        </p>
        <div className="mt-7 flex justify-center">
          <CtaButton variant="gold" testid="final-cta-button" />
        </div>
        <p className="mt-6 font-mono text-[10px] uppercase tracking-[0.2em] text-white/35">
          {config.book.price ? `${config.book.price} • ` : ""}
          {config.book.note}
        </p>
      </Reveal>
    </div>
  </section>
);

export default FinalCta;
